import AddIcon from "@/components/icons/AddIcon";
import MinusIcon from "@/components/icons/MinusIcon";
import Link from "next/link";

const ContactUs = ({ t, active, setActive }) => {
  return (
    <div className="col-span-full md:col-span-6 lg:col-span-3">
      <Link
        href="tel:8002440277"
        className="hidden font-bold uppercase whitespace-nowrap md:block"
      >
        {t("Customer Service")}
      </Link>
      <div
        onClick={() => setActive(active === "contact-us" ? null : "contact-us")}
        className="flex items-center justify-between text-white cursor-pointer md:hidden"
      >
        <h2 className="font-bold uppercase whitespace-nowrap">
          {t("Customer Service")}
        </h2>
        {!active || active !== "contact-us" ? (
          <AddIcon className="size-3" />
        ) : (
          <MinusIcon className="size-3" />
        )}
      </div>
      <ul
        className={`${
          active !== "contact-us" ? "hidden" : "block"
        } mt-3 md:block md:mt-6 max-sm:*:mb-3 *:mb-2 last:*:mb-0`}
      >
        <li>
          <Link prefetch={false} href="/contact-us">
            {t("Contact Us")}
          </Link>
        </li>
        <li className="flex flex-col">
          <span className="opacity-50">{t("Email")}</span>
          <Link prefetch={false} href="mailto:e-customercare@abdulwahed.com">
            e-customercare@abdulwahed.com
          </Link>
        </li>
        <li className="flex flex-col">
          <span className="opacity-50">{t("Telephone")}</span>
          <Link prefetch={false} href="tel:8002440277">
            8002440277{" "}
          </Link>
        </li>
        <li>
          <Link prefetch={false} href="/branches">
            {t("our_branches")}
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default ContactUs;
